module.exports = __webpack_public_path__ + "img/40_38_040_940.bca93fa9.jpg";